module.exports = __webpack_public_path__ + "img/team1.bbd606af.jpg";